export const RENT_ROUTE_NAMES = {
    ADD: "RentAdd",
    EDIT: "RentEdit",
    LIST: "RentList",
};
